export default class wt {
  constructor(t, s, i, h, l) {
    (this.triggerId = t),
      (this.Xr = s),
      (this.$r = i),
      (this.Hr = h),
      (this.Jr = l),
      (this.triggerId = t),
      (this.Xr = s),
      (this.$r = i),
      (this.Hr = h),
      (this.Jr = l);
  }
  static fromJson(t, s, i, h, l) {
    return null == t || null == t.trigger_id
      ? null
      : new wt(t.trigger_id, s, i, h, l);
  }
}
